import { useRouteError } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import {
  DARK_GREY,
  DEEP_PURPLE,
  DEEP_PURPLE_HOVERED,
  DEEP_PURPLE_PRESSED,
  LIGHTER_GREY,
  WHITE,
} from '../styles/colors';
import { useParams } from 'react-router-dom';

const errors = {
  "VOUCHER_NOT_FOUND": "Gift not found.",
  "VOUCHER_ALREADY_USED": "This gift has already been redeemed.",
  "VOUCHER_ERROR": "Unexpected error.",
}

export default function ErrorPage() {
  const error = useRouteError();
  const errorCode = useParams().errorMessage;
  const errorMessage = errors[errorCode] || "Unknown error";
  console.error(error);

  const styles = {
    input: {
      display: 'flex',
      '& .MuiFilledInput-root': {
        borderRadius: 0,
        color: DARK_GREY,
        background: WHITE,
        '&:hover': {
          '&::before': {
            border: 'none',
          },
          '&::after': {
            border: 'none',
          },
        },
        '&::before': {
          border: 'none',
        },
        '&::after': {
          border: 'none',
        },
      },
    },
    createAccountBtn: {
      width: '100%',
      maxWidth: '600px',
      padding: '15px 0',
      background: DEEP_PURPLE,
      borderRadius: '50px',
      boxShadow: 'none',
      fontSize: '12px',
      fontFamily: 'GeometriaExtraBold',
      fontWeight: 900,
      '&: hover': {
        background: DEEP_PURPLE_HOVERED,
      },
      '&:active': {
        background: DEEP_PURPLE_PRESSED,
      },
    },
    box2: {
      marginLeft: 'auto',
      marginRight: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '60px 20px 35px',
      bgcolor: LIGHTER_GREY,
      color: DARK_GREY,
      textAlign: 'center',
    },
  };

  return (
    <>
    <Box id="error-page" sx={styles.box2} component="section">
      <Typography
        sx={{ mb: '20px', fontWeight: 900 }}
        variant="h5"
        component="h1"
        gutterBottom
      >
        Whoops!
      </Typography>
      <Typography sx={{ mb: '20px' }} variant="subtitle1">
        <div>
          <p>
            <b>{errorMessage || error.statusText || error.message}</b>
          </p>
          <p>If you think there’s some mistake, please contact us at <a href="mailto:support@funexpected.org">support@funexpected.org</a></p>
        </div>
      </Typography>
    </Box>
    </>
  );
}
